export interface TextInputRoundedProps {
    placeholder?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
    type?: string;
    children: React.ReactElement;
    error?: boolean;
    value: string;
}

const TextInputRounded = ({ children, placeholder, onChange, type = 'text', error, value = '' }: TextInputRoundedProps) => {
    return (
        <div className="flex flex-col pt-4">
            <div className="flex relative">
                <span className={`inline-flex items-center px-3 border-t bg-white border-l border-b ${error ? 'border-red-700-300' : 'border-gray-300'} text-gray-500 shadow-sm text-sm`}>{children}</span>
                <input
                    onChange={onChange}
                    type={type}
                    value={value}
                    id="design-login-email"
                    className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
};

export default TextInputRounded;
